import shiftAcceptanceDetailsHtml from './shiftAcceptanceDetailsComponent.html';

class ShiftAcceptanceDetailsCtrl {
  constructor(EventCollection, ShiftAcceptanceUtils, possessiveFilter, $uibModal) {
    'ngInject';

    Object.assign(this, { EventCollection, ShiftAcceptanceUtils, possessiveFilter, $uibModal });
  }

  get isPendingAcceptance() {
    return this.ShiftAcceptanceUtils.isPendingAcceptance(this.shift);
  }

  get isRejected() {
    return this.ShiftAcceptanceUtils.isRejectedStatus(this.shift);
  }

  isPendingReccurrenceNotification() {
    return (
      this.notification && this.notification.type === 'shift_pending_acceptance' && this.shift.rrule
    );
  }

  getTitle() {
    const namePosessive = this.possessiveFilter(this.shift.user.name);
    if (this.isPendingAcceptance) {
      return this.shift.user.isMe ? 'Waiting for your reply' : `Waiting for ${namePosessive} reply`;
    }

    return this.shift.user.isMe
      ? 'You have denied this shift'
      : `${this.shift.user.name} has denied this shift`;
  }
}

export default {
  controller: ShiftAcceptanceDetailsCtrl,
  controllerAs: 'ctrl',
  bindings: {
    shift: '<',
    notification: '<?',
    goToConfirmationState: '&',
  },
  templateUrl: shiftAcceptanceDetailsHtml,
};
